import sample_1 from './100_51326.jpg';
import sample_2 from './100_51335.jpg';
import sample_3 from './100_51340.jpg';

export const dynamicFlameImpressions = {
    sample_1,
    sample_2,
    sample_3,
};
